import script from "./CCNetflix.vue?vue&type=script&setup=true&lang=js"
export * from "./CCNetflix.vue?vue&type=script&setup=true&lang=js"

import "./CCNetflix.vue?vue&type=style&index=0&id=3d7a116c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7a116c"]])

export default __exports__